module.exports = __webpack_public_path__ + "img/org_4.44b4c93d.jpeg";